define('CustomProductCollection.PDP.Styles.View', [
    'SCView',
    'custom_product_collection_pdp_styles_view.tpl'
], function CustomProductCollectionPDPStylesViewModule(
    SCViewComponent,
    template
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    /**
     * PDP styles view for custom product collection.
     * Adds parent/child context flags to the template.
     * @constructor
     * @param {Object} options - View options (unused, but included for SCView compatibility)
     */
    function CustomProductCollectionPDPStylesView(options) {
        SCView.call(this);

        this.options = options || {};
        this.template = template;

        this.attributes = {
            id: 'CustomProductCollectionPDPStylesView',
            'class': 'CustomProductCollection-PDP-Styles-View'
        };

        // Require context data for item info
        this.contextDataRequest = ['item'];
    }

    // Inherit parent instance methods.
    CustomProductCollectionPDPStylesView.prototype = Object.create(SCView.prototype);
    CustomProductCollectionPDPStylesView.prototype.constructor =
        CustomProductCollectionPDPStylesView;

    /**
     * Returns context variables for the PDP styles template.
     * @returns {Object} { parent: boolean, child: boolean }
     */
    CustomProductCollectionPDPStylesView.prototype.getContext = function getContext() {
        var item = this.contextData.item();

        return {
            parent: item.custitem_cpc_is_parent_item,
            child: item.custitem_cpc_is_child_item
        };
    };

    // Return the AMD constructor.
    return CustomProductCollectionPDPStylesView;
});
